module.exports = __webpack_public_path__ + "static/media/cover-image-nihr-2.88f15dc9.jpg";